export const SHOP_URL = "https://edu-robo-shop.com";
